<template>
  <div>
    <el-dialog :title="editData.title" :visible.sync="editData.show" center width="400px">
      <el-form :model="formData" label-width="100px">
        <el-form-item :label="$t('PlatformCurrency')">
          <el-input disabled v-model="formData.PSymbol" :placeholder="$t('PlatformCurrency')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('transactionCurrency')">
          <el-select style="width:100%" disabled v-model="formData.Symbol" :placeholder="$t('transactionCurrency')" clearable>
            <el-option label="brl" value="brl"> </el-option>
            <el-option label="cny" value="cny"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('depositExchangeRaten')">
          <el-input v-model="formData.RechargeRate" :placeholder="$t('depositExchangeRaten')" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('TotalRebateAmountUT')">
          <el-input v-model="formData.WithwardRate" :placeholder="$t('WithdrawalRate')" clearable></el-input>
        </el-form-item>
        <el-form-item  :label="$t('GoogleVerificationCode')">
          <el-input v-model="formData.GoogleCode"   :placeholder="$t('GoogleVerificationCode')" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="save">{{$t('Save')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    editData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      formData: {
        PSymbol: "",
        Symbol: "",
        RechargeRate: "",
        WithwardRate: "",
        GoogleCode: "",
      },
    };
  },
  created() {
    this.formData.PSymbol = this.editData.data.PSymbol;
    this.formData.Symbol = this.editData.data.Symbol;
    this.formData.RechargeRate = this.editData.data.RechargeRateEx;
    this.formData.WithwardRate = this.editData.data.WithwardRateEx;
  },
  methods: {
    save() {
      this.$emit("saveData", this.formData);
    },
  },
};
</script>

<style  scoped>
</style>